import * as React from "react";
import Head from "./Head";
import Loader from "../components/Loader";

// Side Modal
export const SideModal = ({ children }) => {
  return (
    <div className="modal modal--side" onClick={(e) => e.stopPropagation()}>
      {children}
    </div>
  );
};

export const SideModalContent = ({ children }) => {
  return <div className="modal__content">{children}</div>;
};

// Popup modal
export const PopupModal = ({ children }) => {
  return (
    <div className="modal modal--pop modal--invoice" onClick={(e) => e.stopPropagation()}>
      {children}
    </div>
  );
};

// Overlay Container
export const Overlay = ({ onClick, isLoading = false, children }) => {
  return (
    <div className="ol__cont" onClick={onClick}>
      {isLoading && <Loader className="load--ol" />}
      {children}
    </div>
  );
};
